import { Link } from "react-router-dom";
import { useShop } from "@/store";
import { M } from "@/data/catalogue";
import { Reveal, MaskedLines } from "@/components/motion";

export default function Story() {
  const { t } = useShop();
  const s = (k) => t(`storyp.${k}`);
  return (
    <>
      <section className="hero" style={{ minHeight: "min(60vh,560px)" }}>
        <div className="copy">
          <div className="eyebrow">{s("eb")}</div>
          <MaskedLines lines={[t("nav.story")]} testid="story-title" />
          <p className="lede">{s("h")}</p>
        </div>
        <div className="media"><img className="bg" src={M.dunes} alt="Dunes of La Guajira" /></div>
      </section>

      <section className="sec">
        <div className="wrap split">
          <Reveal>
            <h2 style={{ fontSize: "clamp(30px,3.6vw,46px)" }}>{s("l1")}</h2>
            <p className="lede" style={{ marginTop: 18 }}>{s("p1")}</p>
            <p className="lede">{s("p2")}</p>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="mosaic">
              <div><img src={M.hands} alt="Weaver's hands" loading="lazy" /></div>
              <div><img src={M.yarn} alt="Cotton yarn" loading="lazy" /></div>
              <div><img src={M.artisan1} alt="Wayuu artisan" loading="lazy" /></div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="sec alt center">
        <div className="wrap">
          <Reveal><p className="quote">{t("qbanner.q")}</p><div className="rule" /></Reveal>
        </div>
      </section>

      <section className="sec">
        <div className="wrap grid g2" style={{ textAlign: "center" }}>
          {[["mis", "misT"], ["vis", "visT"]].map(([a, b], i) => (
            <Reveal key={a} delay={i * 0.1}>
              <div>
                <span className="orn" />
                <h3 style={{ margin: "16px 0 12px", letterSpacing: ".14em", textTransform: "uppercase", fontSize: 14, fontFamily: "var(--body)", fontWeight: 500 }}>{s(a)}</h3>
                <p className="lede" style={{ margin: "0 auto" }}>{s(b)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="sec alt">
        <div className="wrap">
          <div className="pillars">
            {s("pil").map((x, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div style={{ padding: 0 }}>
                  <span className="orn" />
                  <b>{x[0]}</b>
                  <p>{x[1]}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="sec">
        <div className="wrap split">
          <Reveal><div className="im"><img src={M.steps} alt="Wayuu bags on sandstone steps" loading="lazy" /></div></Reveal>
          <Reveal delay={0.12}>
            <div className="eyebrow">{t("nav.story")}</div>
            <h2>{s("br")}</h2>
            <p className="lede">{s("brT")}</p>
          </Reveal>
        </div>
      </section>

      <section className="sec alt">
        <div className="wrap">
          <Reveal><div className="eyebrow">{s("tl")}</div></Reveal>
          <div className="timeline" style={{ marginTop: 22 }} data-testid="story-timeline">
            {s("tls").map((x, i) => (
              <Reveal key={x[0]} delay={i * 0.08}>
                <div style={{ padding: 0 }}><b>{x[0]}</b><p>{x[1]}</p></div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="sec dark center">
        <div className="wrap">
          <Reveal>
            <div className="eyebrow" style={{ color: "#E8B7A3" }}>{t("coll.eb")}</div>
            <h2 style={{ margin: "12px 0 26px" }}>{t("coll.h")}</h2>
            <Link className="btn light" to="/shop" data-testid="story-shop-cta">{t("coll.all")}</Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
